export const formatNumberWithCommas = (number?: number) => new Intl.NumberFormat('en-US').format(number || 0)
